"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-agata-de-goti": {
    "0d6a73c9": [{
      "hkey": "8649b646",
      "slug": "faggiano-cotugni-verroni",
      "name": "Faggiano-Cotugni-Verroni",
      "primary": true,
      "skipSearch": false
    }],
    "faggiano": [{
      "hkey": "8649b646",
      "slug": "faggiano-cotugni-verroni",
      "name": "Faggiano-Cotugni-Verroni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5d228fc8": [{
      "hkey": "46d7779b",
      "slug": "migliara-san-silvestro",
      "name": "Migliara-San Silvestro",
      "primary": true,
      "skipSearch": false
    }],
    "san-silvestro": [{
      "hkey": "46d7779b",
      "slug": "migliara-san-silvestro",
      "name": "Migliara-San Silvestro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;